// client/src/pages/Admin/ResourceManager/components/ResourceHeader.tsx

import React from 'react';
import { FileText, RefreshCw, Plus } from 'lucide-react';

interface ResourceHeaderProps {
  onRefresh: () => void;
  onNewResource: () => void;
}

export const ResourceHeader: React.FC<ResourceHeaderProps> = ({ onRefresh, onNewResource }) => {
  return (
    <div className="page-header">
      <div className="page-header-content">
        <div className="page-header-left">
          <div className="page-header-icon">
            <FileText size={28} />
          </div>
          <div>
            <h1 className="page-title">Resource Library</h1>
            <p className="page-description">
              Manage publications, reports, datasets, media, and downloadable content
            </p>
          </div>
        </div>
        <div className="page-header-actions">
          <button
            type="button"
            className="btn-secondary"
            onClick={onRefresh}
            aria-label="Refresh resources"
          >
            <RefreshCw size={18} />
            <span>Refresh</span>
          </button>
          <button
            type="button"
            className="btn-primary"
            onClick={onNewResource}
            aria-label="Create new resource"
          >
            <Plus size={20} />
            <span>New Resource</span>
          </button>
        </div>
      </div>
    </div>
  );
};